import { useQuery } from "@tanstack/react-query";
import ExhibitionService from "../service/ExhibitionService";

export function useExhibitions() {
  const {
    data: exhibitions,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["exhibitions"],
    queryFn: ExhibitionService.getAll,
    cacheTime: 1000 * 60 * 60, // Mantieni i dati in cache per 60 minuti
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    onSuccess: (data) => {
      localStorage.setItem("exhibitionsData", JSON.stringify(data));
    },
    initialData: () => {
      const savedData = localStorage.getItem("exhibitionsData");
      return savedData ? JSON.parse(savedData) : undefined;
    },
    error: (err) => {
      throw new Error(
        "Fatching data failed: " + err.message || "Network Error",
      );
    },
  });

  return {
    exhibitions,
    isLoading,
    error,
  };
}
